<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="documents"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :refresh="needRefresh"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading mr-auto">Документы</h2>
      <button type="button" class="btn btn-primary" @click="documents">Добавить документ</button>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        @load-more="$refs.data.loadMore()"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
      >
        <el-table-column prop="name" sortable="keyword" align="center" label="Название">
          <template slot-scope="{ row }">
            <div class="text-left">
              <a :href="row.url">{{ row.name }}</a>
            </div>
          </template>
        </el-table-column>
        <table-column-checkbox align="center" label="Оператор" checked="roles.service"></table-column-checkbox>
        <table-column-checkbox align="center" label="Техник" checked="roles.tech"></table-column-checkbox>
        <table-column-checkbox align="center" label="Руководитель операторов" checked="roles.service_superior"></table-column-checkbox>
        <table-column-checkbox align="center" label="Руководитель техников" checked="roles.tech_superior"></table-column-checkbox>
        <el-table-column align="center" label="Действие">
          <template slot-scope="{ row }">
            <button type="button" class="btn btn-sm btn-outline-primary" @click="editDoc(row.id)">Редактировать</button>
            <btn-action class="btn btn-sm btn-outline-danger" @click="() => deleteDoc(row.id)">Удалить</btn-action>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import { cloneDeep } from 'lodash'
  import DocumentstModal from '../../../components/documents-modal.vue'
  import TableColumnCheckbox from '../../../components/table-column-checkbox.vue'

  export default {
    metaInfo: { title: 'Документы' },
    components: {
      TableColumnCheckbox,
    },
    data () {
      return {
        updateList: 0,
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
        needRefresh: false,
      }
    },
    methods: {
      deleteDoc (id) {
        if (!window.confirm('Действительно удалить файл?')) return
        const findDoc = this.findDocById(id)
        return api.delete(`documents/${id}`, {'params': findDoc.find})
          .then(() => {
            this.refreshData()
          })
      },
      editDoc (id) {
        this.$root.showModal(DocumentstModal, {
          currentDoc: cloneDeep(this.findDocById(id).find),
        }).then((saved) => {
          if (saved) {
            this.refreshData()
          }
        })
      },
      documents () {
        this.$root.showModal(DocumentstModal).then((saved) => {
          if (saved) {
            this.refreshData()
          }
        })
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const sortable = sort.column.sortable
          // set prop name
          let prop = (sortable === 'keyword') ? sort.prop + '.keyword' : sort.prop
          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
      findDocById (id) {
        let index = 0

        const find = this.data.data.find((doc, idx) => {
          index = idx
          return doc.id === id
        })

        return { index, find }
      },
      refreshData () {
        this.needRefresh = true
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/documents/index.vue